import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/shared/components/ui/tabs";
import { Brain, Wrench, Loader2 } from "lucide-react";
import IntegrationsBase from "@/features/Integrations/components/IntegrationsBase";
import { PlatformAiModelsSettings } from "./PlatformAiModelsSettings";
import { PlatformAiService } from "@/features/PlatformSettings/services/platformAiService";

/**
 * A área de Plataforma, no superadministrador (AB#85605).
 *
 * Duas abas, na ordem em que o trabalho acontece: primeiro se cadastra a integração do
 * provedor, depois se escolhe o modelo de cada finalidade.
 *
 * A aba de integrações é a MESMA tela das organizações, apontada para a organização da
 * plataforma — e não uma segunda tela de cadastro. Com isso a credencial é
 * cifrada pelo mesmo mecanismo, o catálogo de modelos vem do mesmo lugar e nada aqui precisa
 * saber criptografar coisa alguma.
 *
 * O título da página vem do breadcrumb do Navbar, como nas demais telas de `/admin`.
 */
export function PlatformSettings() {
  const { t } = useTranslation();

  // Mesma chave da tela de modelos: as duas abas leem a organização da plataforma de uma
  // consulta só.
  const { data: platform, isLoading } = useQuery({
    queryKey: ["platform-ai-models"],
    queryFn: () => PlatformAiService.getModels(),
  });

  return (
    <div className="w-full">
      <Tabs defaultValue="integrations" className="w-full">
        <div className="flex items-center justify-between border-b">
          <TabsList>
            <TabsTrigger value="integrations">
              <Wrench className="mr-2 h-4 w-4" />
              {t("settings.platformIntegrations.tab")}
            </TabsTrigger>
            <TabsTrigger value="ai-models">
              <Brain className="mr-2 h-4 w-4" />
              {t("settings.tabs.models")}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="integrations" className="mt-4 w-full px-4">
          {isLoading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin" />
            </div>
          ) : platform?.organization_id ? (
            <IntegrationsBase organizationId={platform.organization_id} />
          ) : (
            <p className="py-8 text-center text-sm text-muted-foreground">
              {t("settings.platformModels.missingOrganization")}
            </p>
          )}
        </TabsContent>

        <TabsContent value="ai-models" className="mt-4 w-full px-4">
          <PlatformAiModelsSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}
